import React, { useEffect, useState } from 'react';
import Button from '@edusogno/primitives/button.js';
import { useModalAction } from '@/contexts/modal/Context';
import useGlobals from '@/utils/hooks/useGlobals';

type SelectorProps = {
  title: string;
  items: string[];
  selectedItems: string[];
  onItemToggle: (item: string) => void;
};

const Selector: React.FC<SelectorProps> = ({ title, items, selectedItems, onItemToggle }) => {
  return (
    <section>
      <h2 className="font-semibold text-[--secondary]">{title}</h2>
      <div className="grid grid-cols-3 until-md:grid-cols-2 grid-flow-row gap-3 mt-3.5">
        {items.map((item) => (
          <Button
            key={item}
            onClick={() => onItemToggle(item)}
            variant="contained"
            className='h-[30px] text-xs'
            size="sm"
            color={selectedItems.includes(item) ? 'primary' : 'white'}
          >
            {item}
          </Button>
        ))}
      </div>
    </section>
  );
};

const MaterialsFilterModal: React.FC = () => {
  const { closeModal } = useModalAction();
  const { updateFilters, filters } = useGlobals();
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [selectedSubtypes, setSelectedSubtypes] = useState<string[]>([]);

  const toggleItemSelection = (items: string[], item: string): string[] => {
    const index = items.indexOf(item);
    if (index === -1) {
      return [...items, item];
    } else {
      return items.filter(currentItem => currentItem !== item);
    }
  };

  const handleTypeToggle = (type: string) => {
    setSelectedTypes(toggleItemSelection(selectedTypes, type));
  };

  const handleSubtypeToggle = (subtype: string) => {
    setSelectedSubtypes(toggleItemSelection(selectedSubtypes, subtype));
  };

  const handleApplyClick = () => {
    updateFilters({ types: selectedTypes, subtypes: selectedSubtypes });
    closeModal();
  };

  useEffect(() => {
    if (filters.types) setSelectedTypes(filters.types);
    if (filters.subtypes) setSelectedSubtypes(filters.subtypes);
  }, [filters.types, filters.subtypes]);

  return (
    <main className="flex flex-col gap-6 px-5 py-7 text-xs leading-3 whitespace-nowrap bg-white rounded-lg">
      <Selector
        title="Type"
        items={['General', 'Speaking', 'Reading', 'Writing', 'Listening', 'One-to-one']}
        selectedItems={selectedTypes}
        onItemToggle={handleTypeToggle}
      />
      <Selector
        title="Subtype"
        items={['Zero', 'Starter', 'Beginner', 'Basic', 'Intermediate', 'Advanced']}
        selectedItems={selectedSubtypes}
        onItemToggle={handleSubtypeToggle}
      />
      <div className="flex justify-end items-baseline">
        <Button
          onClick={handleApplyClick}
          color='green'
          size='sm'
          className='w-[100px]'
        >
          Apply
        </Button>
      </div>
    </main>
  );
};

export default MaterialsFilterModal;
